import { CheckboxFilter } from '@lifebit-ai/lds'
import React from 'react'

import type { Option } from 'modules/types'
import { useGetWorkspacesFromDataAccessRequests } from 'services/data-access-requests/hooks/useGetWorkspacesFromDataAccessRequests'

interface DataAccessRequestWorkspacesFilterProps {
  onApply: (filteredOptions: Option[]) => void
  onReset: () => void
}

export const DataAccessRequestWorkspacesFilter = ({ onApply, onReset }: DataAccessRequestWorkspacesFilterProps) => {
  const workspacesQuery = useGetWorkspacesFromDataAccessRequests()

  const options =
    workspacesQuery.data?.data.map(workspace => ({
      label: workspace.name,
      value: workspace._id
    })) ?? []

  return (
    <CheckboxFilter
      label="Workspaces"
      loading={workspacesQuery.isLoading}
      onApply={onApply}
      options={options}
      onReset={onReset}
      searchFieldPlaceholder="Search workspaces"
    />
  )
}
